var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c(
      "div",
      {
        staticClass: "modal fade",
        class: _vm.oncancel ? "show" : "show",
        style: _vm.oncancel ? "display: block; padding-left: 0px;" : "",
        attrs: { tabindex: "-1", role: "dialog" },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
          _c("div", { staticClass: "modal-content shadow-3" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "div",
                {
                  staticClass:
                    "icon icon-shape rounded-3 bg-soft-danger text-danger text-lg me-4",
                },
                [_c("i", { staticClass: "bi bi-trash3" })]
              ),
              _vm._v(" "),
              _c("div", [
                _c("h5", { staticClass: "mb-1" }, [
                  _vm._v(
                    _vm._s(_vm.state == 24 ? "Reembolsar" : "Anular") +
                      " registro"
                  ),
                ]),
                _vm._v(" "),
                _c("small", { staticClass: "d-block text-xs text-muted" }, [
                  _vm._v("¿Realmente desea "),
                  _c(
                    "span",
                    { staticStyle: { "text-transform": "lowercase" } },
                    [_vm._v(_vm._s(_vm.state == 24 ? "Reembolsar" : "Anular"))]
                  ),
                  _vm._v(" estos registros?"),
                  _c("br"),
                  _vm._v(" Este proceso no se puede deshacer."),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ms-auto" }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "mb-3" }, [
                _c("small", { staticClass: "text-sm" }, [_vm._v("Nota")]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.note,
                      expression: "note",
                    },
                  ],
                  staticClass: "form-control from-control-sm",
                  attrs: { rows: "4" },
                  domProps: { value: _vm.note },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.note = $event.target.value
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c("div", [
                  _c("p", { staticClass: "text-sm" }, [
                    _vm._v("Ingresa tu contraseña para permitir esta acción"),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("v-text-field", {
                    staticClass: "form-control form-control-sm",
                    attrs: {
                      "append-icon": _vm.type ? "mdi-eye" : "mdi-eye-off",
                      type: _vm.type ? "text" : "password",
                      "hide-details": "",
                    },
                    on: {
                      "click:append": function ($event) {
                        _vm.type = !_vm.type
                      },
                    },
                    model: {
                      value: _vm.password,
                      callback: function ($$v) {
                        _vm.password = $$v
                      },
                      expression: "password",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-h btn-danger px-3",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.CANCEL()
                    },
                  },
                },
                [
                  _vm.count == 1
                    ? _c(
                        "div",
                        {
                          staticClass: "spinner-border spinner-border-sm",
                          attrs: { role: "status" },
                        },
                        [
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("Loading..."),
                          ]),
                        ]
                      )
                    : _c("span", [_vm._v("Confirmar")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-h btn-dark px-3",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("onclose")
                    },
                  },
                },
                [_vm._v("Cancelar")]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }